import { useState, useEffect } from 'react'

// Keep in sync with --mobile in src/breakpoints.css (CSS can't read this constant
// and JS can't read @custom-media, so the value lives in both — change both together).
const MOBILE_BREAKPOINT = 640
const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`)

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(() => mediaQuery.matches)

    useEffect(() => {
        const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
        mediaQuery.addEventListener('change', handler)
        return () => mediaQuery.removeEventListener('change', handler)
    }, [])

    return isMobile
}

export default useIsMobile
